export default {

    data() {
        return {
            timeout: null,
            delay: 250
        }
    },

    methods: {
        delayedSubmit({event = 'submit', value}) {
            this.setTimeout(() => {
                this.$emit(event, value)
                this.timeout = null
            })
        },

        setTimeout(callback) {
            if (this.timeout)
                clearTimeout(this.timeout)

            this.timeout = setTimeout(callback, this.delay)
        },
    }
}
